export const SET_AUTH_DATA_CHANNEL = 'SET_AUTH_DATA_CHANNEL';
export const GET_AUTH_DATA_CHANNEL = 'GET_AUTH_DATA_CHANNEL';
export const REMOVE_AUTH_DATA_CHANNEL = 'REMOVE_AUTH_DATA_CHANNEL';
export const LOGOUT_CHANNEL = 'LOGOUT_CHANNEL';
export const IS_GETTING_TOKEN_CHANNEL = 'IS_GETTING_TOKEN_CHANNEL';
